import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import ServiceSide from "./ServiceSide";
import BgImg from "../../assets/portfolio/bg2.png";
import CMS2 from "../../assets/service/cms.png";
import CMSHERO from "../../assets/service/servicecms.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OurClients from "../OurClients/OurClients";

import {
  faFileAlt,
  faEdit,
  faShareSquare,
  faShieldAlt,
  faPencilAlt,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import {
  faMoneyBillWave,
  faChartLine,
  faArrowUpRightDots,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import Partners from "../ServiceImp/Scroll";
import { Helmet } from "react-helmet-async";
function ContentManagementSystem() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true }); // Initialize AOS with animation duration and animation trigger once
  }, []);
  // faq
  const [openIndexes, setOpenIndexes] = useState([]);

  const toggleItem = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const toggleAll = () => {
    if (openIndexes.length === faqData.length) {
      setOpenIndexes([]);
    } else {
      setOpenIndexes(faqData.map((_, i) => i));
    }
  };

  const faqData = [
    {
      question: "What is a Content Management System (CMS)?",
      answer:
        "A CMS is software that helps users create, manage, and modify digital content on a website without needing technical skills.",
    },
    {
      question: "Why choose Deetyasoft for CMS development?",
      answer:
        "Deetyasoft provides custom CMS development that is secure, scalable, and tailored to your business needs, making content management simple and effective.",
    },
    {
      question: "Can Deetyasoft integrate CMS with existing websites?",
      answer:
        "Yes, we can integrate a CMS into your existing website to enhance functionality and give you full control over your content.",
    },
    {
      question: "Is the CMS mobile-friendly and responsive?",
      answer:
        "Absolutely. Our CMS solutions are fully responsive, ensuring smooth content management and display across all devices.",
    },
    {
      question: "How can Deetyasoft’s CMS improve my website performance?",
      answer:
        "Deetyasoft’s CMS solutions are optimized for speed, SEO, and mobile responsiveness, helping your website load faster, rank higher on search engines, and provide a seamless experience to users.",
    },
  ];
  // benifits section
  const benefits = [
    {
      icon: faPencilAlt, // Icon for ease of use
      title: "User-Friendly",
      description:
        "Easy to use, no expert knowledge required to manage the content.",
      bgColor: "bg-purple-100",
    },
    {
      icon: faMoneyBillWave, // Icon for cost-efficiency
      title: "Cost Effective",
      description:
        "No specialized coding skills required, CMS can save time and money.",
      bgColor: "bg-orange-100",
    },
    {
      icon: faUsers, // Icon for collaboration
      title: "Collaborative",
      description: "Multiple users can collaborate at a single point of time.",
      bgColor: "bg-teal-100",
    },
    {
      icon: faChartLine, // Icon for scalability
      title: "Scalable",
      description: "Easily scalable with the growth of the business.",
      bgColor: "bg-indigo-100",
    },
    {
      icon: faArrowUpRightDots, // Icon for SEO
      title: "SEO Optimized",
      description: "SEO optimisation.",
      bgColor: "bg-pink-100",
    },
  ];

  const pillars = [
    {
      icon: faFileAlt, // Icon for Content Creation
      title: "Content Creation",
      description:
        "Create and manage engaging content with rich text, images, and media support.",
      bgColor: "bg-red-100",
    },
    {
      icon: faEdit, // Icon for Content Editing
      title: "Content Editing",
      description:
        "Easily edit and update content with a user-friendly interface.",
      bgColor: "bg-yellow-100",
    },
    {
      icon: faShareSquare, // Icon for Content Publishing
      title: "Content Publishing",
      description:
        "Publish content seamlessly across multiple platforms and channels.",
      bgColor: "bg-indigo-100",
    },
    {
      icon: faShieldAlt, // Icon for Content Security
      title: "Content Security",
      description:
        "Ensure your content is secure, with proper access control and backup options.",
      bgColor: "bg-gray-100",
    },
  ];
  // seo
  const schemas = [
    {
      "@context": "http://schema.org",
      "@type": "Organization",
      name: "Deetya Soft Pvt Ltd",
      description:
        "Manage your website effortlessly with Deetyasoft’s secure, scalable, and user-friendly CMS, customized for your business, without technical skills needed.",
      image: "https://deetyasoft.com/static/media/cms.9d71d4d5f844345628a7.png",
      logo: "https://www.deetyasoft.com/images/logo.png",
      url: "https://www.deetyasoft.com",
      telephone: ["+91-9015350505", "+91-9717055088"],
      email: "info@deetyasoft.com",
      sameAs: [
        "https://www.linkedin.com/company/deetya-soft-private-limited",
        "https://www.facebook.com/deetyasoftprivatelimited",
        "https://www.instagram.com/deetyasoft",
        "https://www.youtube.com/@deetyasoft",
        "https://www.crunchbase.com/organization/deetyasoft",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
        addressLocality: "Ghaziabad",
        addressRegion: "Uttar Pradesh",
        postalCode: "201014",
        addressCountry: "IN",
      },
    },
    {
      "@context": "http://schema.org",
      "@type": "Organization",
      url: "https://www.deetyasoft.com",
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-981-862-7588",
          contactType: "technical support",
          areaServed: "IN",
        },
        {
          "@type": "ContactPoint",
          telephone: "+91-901-535-0505",
          contactType: "sales",
          areaServed: "IN",
        },
      ],
    },
    {
      "@context": "http://schema.org",
      "@type": "Review",
      author: {
        "@type": "Person",
        name: "Parshan",
      },
      reviewBody:
        "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
      url: "https://www.deetyasoft.com/",
      description:
        "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
      datePublished: "2025-06-17",
      name: "Deetya Soft Pvt Ltd",
      reviewRating: {
        "@type": "Rating",
        worstRating: "1",
        ratingValue: "5",
        bestRating: "5",
      },
      itemReviewed: {
        "@type": "Organization",
        name: "Deetya Soft Pvt Ltd",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What is a Content Management System (CMS)?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "A CMS is software that helps users create, manage, and modify digital content on a website without needing technical skills.",
          },
        },
        {
          "@type": "Question",
          name: "Why choose Deetyasoft for CMS development?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Deetyasoft provides custom CMS development that is secure, scalable, and tailored to your business needs, making content management simple and effective.",
          },
        },
        {
          "@type": "Question",
          name: "Can Deetyasoft integrate CMS with existing websites?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we can integrate a CMS into your existing website to enhance functionality and give you full control over your content.",
          },
        },
        {
          "@type": "Question",
          name: "Is the CMS mobile-friendly and responsive?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely. Our CMS solutions are fully responsive, ensuring smooth content management and display across all devices.",
          },
        },
        {
          "@type": "Question",
          name: "How can Deetyasoft’s CMS improve my website performance?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Deetyasoft’s CMS solutions are optimized for speed, SEO, and mobile responsiveness, helping your website load faster, rank higher on search engines, and provide a seamless experience to users.",
          },
        },
      ],
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Content Management System Services, CMS Service | Deetyasoft
        </title>
        <meta
          name="description"
          content="Manage your website effortlessly with Deetyasoft’s secure, scalable, and user-friendly CMS, customized for your business, without technical skills needed."
        />
        <meta
          name="keywords"
          content="Content management system services.CMS development company in India, custom CMS development, CMS integration services, SEO-friendly CMS website content management, scalable CMS solutions, user-friendly CMS platforms, Deetyasoft CMS services, dynamic content management"
        />
        <link
          rel="canonical"
          href="https://deetyasoft.com/content-management-system"
        />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://deetyasoft.com/content-management-system"
        />
        <meta
          property="og:title"
          content="Content Management System Services, CMS Service | Deetyasoft"
        />
        <meta
          property="og:description"
          content="Manage your website effortlessly with Deetyasoft’s secure, scalable, and user-friendly CMS, customized for your business, without technical skills needed."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/cms.9d71d4d5f844345628a7.png"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://deetyasoft.com/content-management-system"
        />
        <meta
          name="twitter:title"
          content="Content Management System Services, CMS Service | Deetyasoft"
        />
        <meta
          name="twitter:description"
          content="Manage your website effortlessly with Deetyasoft’s secure, scalable, and user-friendly CMS, customized for your business, without technical skills needed."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/cms.9d71d4d5f844345628a7.png"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta http-equiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* <!-- Id+json scripts --> */}

        {schemas?.map((schema, index) => (
          <script
            key={index}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          />
        ))}
      </Helmet>
      {/* heroo section */}

      <div className="relative bg-[#2f68a2] overflow-hidden pb-5 text-white">
        {/* Content */}
        <div className="relative z-20 max-w-7xl mx-auto  px-6 py-10 grid md:grid-cols-2 lg:gap-20 md:gap-10  items-start">
          {/* Left Side */}
          <div>
            <h1 className="text-3xl md:text-4xl font-bold leading-snug mb-4">
              Content Management System
            </h1>
            <p className="text-white/90 mb-6 text:base md:text-lg">
              Are you planning to create your own website? Share your vision
              with us, or take control and build it yourself using our powerful
              Project Maker software. Whether you need a personal blog, a
              stunning portfolio, or a full-fledged business site, we've got the
              tools to make it happen. Start building your dream website today
              and bring your ideas to life!
            </p>
            <button
              className="bg-orange-500   hidden md:block hover:bg-orange-600 text-white px-5 py-3 rounded shadow-md transition"
              onClick={() => {
                const target = document.getElementById("bottomTarget");
                if (target) {
                  target.scrollIntoView({ behavior: "smooth", block: "start" });
                  // Optional offset tweak using window.scrollBy
                  setTimeout(() => {
                    window.scrollBy(0, -100); // scrolls 100px up after reaching the section
                  }, 600);
                }
              }}
            >
              Let's Get Started
            </button>
          </div>

          {/* Right Side Image */}
          <div className="flex justify-center">
            <img
              src={CMSHERO}
              alt="content-managemnet-image"
              className="md:w-[90%] object-contain w-full  max-w-lg animate-float"
            />
          </div>
        </div>

        {/* FIRST CURVE - White */}
        <div className="absolute bottom-0 left-0 w-full z-10">
          <svg
            className="w-full h-auto"
            viewBox="0 0 1440 290"
            preserveAspectRatio="none"
          >
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,160L60,165.3C120,171,240,181,360,165.3C480,149,600,107,720,117.3C840,128,960,192,1080,208C1200,224,1320,192,1380,176L1440,160L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            />
          </svg>
        </div>

        {/* SECOND CURVE - Light Blue */}
        <div className="absolute bottom-[20px] left-0 w-full z-0">
          <svg
            className="w-full h-auto"
            viewBox="0 0 1440 320"
            preserveAspectRatio="none"
          >
            <path
              fill="#a6c7e2" // Light blue like in the image
              fillOpacity="1"
              d="M0,288L60,272C120,256,240,224,360,197.3C480,171,600,149,720,160C840,171,960,213,1080,208C1200,203,1320,149,1380,122.7L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            />
          </svg>
        </div>
      </div>

      {/* second web solution section */}
      <div className="">
        <h2 className="text-xl px-2 md:px-0 md:text-3xl font-semibold text-center mt-4 mb-2 text-gray-600">
          CMS Services
        </h2>
        <div className="md:w-28 w-20 h-1 bg-main mx-auto md:mb-3 mb-1 rounded-full" />

        <p className="text-center text-gray-700 px-4 md:px-20 lg:px-40">
          Streamline your stock, reduce costs, and ensure products are always
          available when needed.
        </p>

        {/* Wrapper that allows scrolling */}
        <div className="px-  md:px-5 sm:px-3 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-[2fr_1fr] gap-3 sm:gap-2 md:gap-8">
          {/* Main Content */}
          <div className="container mx-auto px-4 py-8">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
              {/* Image Section */}

              <div className="w-full md:order-1 order-2 max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
                <img
                  src={CMS2}
                  alt="cms"
                  className="w-full h-full  object-cover"
                />
              </div>

              {/* Text Content Section */}

              <div className="space-y-4 md:text-base text-sm order-2 md:order-1 text-justify">
                <h2 className="text-xl font-semibold text-main md:text-2xl lg:text-3xl">
                  What is a CMS?
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  A Content Management System (CMS) is an application software
                  that manages content stored in a repository, located on the
                  same server, as part of the same software package. Users can
                  create new content, edit existing content, perform editorial
                  processes, and make that content available to others. CMS
                  provides automation for tasks required to effectively manage
                  content. It offers an easy environment to handle digital
                  content such as text, images, music, documents, and more.
                </p>

                <h3 className="text-xl font-semibold text-main md:text-2xl lg:text-3xl mt-4">
                  CMS Categories:
                </h3>
                <ul className="list-disc pl-5 space-y-1 text-gray-700">
                  <li>Web Content Management</li>
                  <li>Enterprise Content Management</li>
                  <li>Digital Assets Management</li>
                  <li>Record Management</li>
                </ul>

                <h3 className="text-xl font-semibold text-main md:text-2xl lg:text-3xl mt-4">
                  Our CMS Services at Deetya Soft
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  At <strong>Deetya Soft</strong>, we are committed to managing
                  and organizing content for your website through efficient
                  content management systems like{" "}
                  <strong>WordPress, Joomla, Drupal</strong>, and more. Our
                  organization has built many websites using CMS-based
                  applications.
                </p>

                <h3 className="text-xl font-semibold text-main md:text-2xl lg:text-3xl mt-4">
                  Static vs Dynamic Websites
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  When starting website development, the first decision is
                  whether the site will be <strong>static</strong> or{" "}
                  <strong>dynamic</strong>. Static websites contain simple
                  content and images with no editing features for the client. In
                  contrast, dynamic websites allow the client to edit, change,
                  or update content any number of times.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  In a dynamic website, a back-end system (known as a CMS) is
                  provided to the client to manage the site's content. This
                  backend can be developed using various technologies such as{" "}
                  <strong>Joomla, Magento, Zend, WordPress, Drupal</strong>, and
                  more, depending on the client’s needs.
                </p>

                <h3 className="text-xl font-semibold text-main md:text-2xl lg:text-3xl mt-4">
                  Our Commitment
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Our expert team ensures top-quality delivery, regardless of
                  the technology you choose. At Deetya Soft, we deliver only the
                  best — nothing less.
                </p>
              </div>
            </div>
          </div>
          {/* Sticky Sidebar */}
          <div className="sticky md:block hidden  top-20 self-start  p-3  h-fit">
            <ServiceSide />
          </div>
        </div>
        {/* patrners */}
        <div>
          <Partners />
        </div>
        {/* make it next section */}
      </div>
      <div
        className="py-5 px-5 relative"
        // data-aos='fade-up'
        style={{
          backgroundImage: `url(${BgImg})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          minHeight: "60vh",
        }}
      >
        <div className="text-center py-10 px-4">
          <h2 className="text-3xl md:text-4xl font-semibold">
            <span className="text-black">Our Power Packed </span>
            <span className="text-sky-500"> Feature</span>
          </h2>

          <div className="relative w-fit mx-auto mt-2">
            <div className="h-[1px] bg-gray-400 md:w-[200px] w-[100px] mx-auto"></div>
            <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
              <div className="w-8 h-[2px] bg-sky-500"></div>
              <div className="w-8 h-[2px] bg-sky-500"></div>
            </div>
          </div>

          <p className="text-gray-800 text-base mt-4">
            What You Get Using Our Inventory Management System
          </p>
        </div>

        <div className="container mx-auto px-4 pb-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {pillars.map((pillar, index) => (
              <div
                key={index}
                className="bg-gray-50 shadow-md  overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                <div className="p-8 text-center">
                  <div
                    className={`w-16 h-16 flex items-center justify-center rounded-full ${pillar.bgColor} mb-4 mx-auto`}
                  >
                    <FontAwesomeIcon
                      icon={pillar.icon}
                      className="text-sky-500 text-2xl"
                    />
                  </div>
                  <h5 className="md:text-lg text-base font-semibold text-gray-800 mb-3">
                    {pillar.title}
                  </h5>
                  <p className="text-gray-600 text-sm">{pillar.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* benifits section */}
      <div className="bg-blue-50 py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-semibold text-main">
              Some Benefits of Content Management System
            </h2>
            <div className="w-40 h-1 bg-main mx-auto mt-2 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-white text-center shadow-md rounded-lg p-6 hover:shadow-lg transition duration-300"
              >
                <div className="text-main text-3xl mb-4">
                  <FontAwesomeIcon icon={benefit.icon} />
                </div>
                <h5 className="text-lg font-bold mb-2">{benefit.title}</h5>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* faq section */}

      <div className="bg-gray-100 py-8" id="bottomTarget">
        <div className="max-w-5xl mx-auto px-4 py-12">
          {/* Header Section */}
          <div className="flex flex-col sm:flex-row items-center sm:justify-between mb-8 gap-4">
            <div className="text-center sm:text-left w-full sm:w-auto">
              <h2 className="text-2xl md:text-3xl font-semibold text-main1">
                Frequently Asked Questions (FAQ)
              </h2>
              <div className="w-20 md:w-40 mx-auto sm:mx-0 border-b-4 border-main1 rounded-full mt-2" />
            </div>

            <button
              onClick={toggleAll}
              className="text-sm font-medium text-black underline hover:text-blue-700 whitespace-nowrap"
            >
              {openIndexes.length === faqData.length
                ? "Collapse all"
                : "Expand all"}
            </button>
          </div>

          {/* FAQ List */}
          <div className="space-y-4">
            {faqData.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-sm overflow-hidden"
              >
                <button
                  onClick={() => toggleItem(index)}
                  className="w-full flex justify-between items-center px-6 py-4 text-left hover:bg-gray-50 transition-colors"
                >
                  <p className="text-base md:text-lg font-medium text-black">
                    {item.question}
                  </p>
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={`w-4 h-4 transform transition-transform ${
                      openIndexes.includes(index) ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {openIndexes.includes(index) && (
                  <div className="px-6 pb-4 text-gray-700 text-sm md:text-base">
                    {item.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* client section */}
      <div>
        <OurClients />
      </div>
    </>
  );
}

export default ContentManagementSystem;

// <div
//       className="relative h-auto md:h-[65vh] lg:h-[80vh] bg-gradient-to-r from-blue-400 to-indigo-50 py-8 md:py-10 overflow-hidden"
//       data-aos="fade-up"
//     >
//       {/* Decorative Circles */}
//       <div
//         className="hidden md:block absolute w-[300px] h-[300px] bg-white/10 rounded-full top-[10%] left-[5%] z-10"
//         data-aos="zoom-in"
//       ></div>
//       <div
//         className="absolute w-[300px] h-[300px] bg-white/10 rounded-full bottom-[15%] right-[10%] z-10"
//         data-aos="zoom-in"
//       ></div>

//       <div className="container mx-auto md:px-6 px-5  relative z-10">
//         <div className="flex flex-col lg:flex-row items-center">
//           {/* Left Text */}
//           <div
//             className="lg:w-1/2 text-center lg:text-left"
//             data-aos="fade-right"
//           >
//             <h1 className="text-3xl md:text-5xl font-semibold text-gray-800">
//               Content Management System
//             </h1>
//             <p className="mt-2 text-base md:text-lg text-black">
//               Are you planning to create your own website? Share your vision
//               with us, or take control and build it yourself using our
//               powerful Project Maker software. Whether you need a personal
//               blog, a stunning portfolio, or a full-fledged business site,
//               we've got the tools to make it happen. Start building your dream
//               website today and bring your ideas to life!
//             </p>
//           </div>

//           {/* Right Image */}

//           <div
//             className="lg:w-1/2 flex justify-center mt-8 lg:mt-0"
//             data-aos="fade-left"
//           >
//             <img
//               src={CMSHERO}
//               alt="cms"
//               className="w-[65%] max-w-lg animate-float"
//             />
//           </div>
//         </div>
//       </div>
//     </div>
